import { ISingleOrder } from '@alberta/konexi-shared';
import { Injectable } from '@angular/core';
import { BaseStateExtension } from 'src/app/common/state/state-extension';
import { SingleOrderModelName } from 'src/app/shared/models/model-names';
import { SingleOrderViewModel } from './single-order-view-model';

@Injectable({ providedIn: 'root' })
export class SingleOrderStateExtension extends BaseStateExtension<ISingleOrder> {
  public get name(): string {
    return SingleOrderModelName;
  }

  async canBeStored(item: ISingleOrder): Promise<boolean> {
    return true;
  }

  protected afterCreateInternal(item: ISingleOrder): void {}

  protected async afterUpdateInternal(item: ISingleOrder): Promise<void> {
    if (
      this.stateRegistry.get<ISingleOrder, SingleOrderViewModel>(SingleOrderModelName, 'selectedItem')?._id ===
      item?._id
    ) {
      await this.stateRegistry.update(SingleOrderModelName, 'selectedItem', item);
    }
  }
  protected removeFromState(item: ISingleOrder): void {}
}
